import {
  matBusinessOutline,
  matCalendarMonthOutline,
  matChatBubbleOutline,
  matHeadsetOutline,
  matInputOutline,
  matNewspaperOutline,
  matVideoLibraryOutline,
  matWebStoriesOutline,
} from '@ng-icons/material-icons/outline';
import {
  matAltRoute,
  matBadge,
  matBalance,
  matCameraAlt,
  matChat,
  matCheckBox,
  matDiamond,
  matEco,
  matEmojiEvents,
  matEvent,
  matEventAvailable,
  matFitnessCenter,
  matFlag,
  matFunctions,
  matHandshake,
  matHome,
  matHowToReg,
  matHub,
  matInfo,
  matLightbulb,
  matListAlt,
  matLocalBar,
  matMenuBook,
  matNewspaper,
  matPeopleAlt,
  matPersonRemove,
  matPets,
  matPlace,
  matPublic,
  matRestaurant,
  matSpeed,
  matSportsScore,
  matStar,
  matSupport,
  matTextSnippet,
  matWorkspacePremium,
} from '@ng-icons/material-icons/baseline';
import {
  matDesignServicesRound,
  matGridViewRound,
} from '@ng-icons/material-icons/round';

export const DATA_DRIVEN_ICONS = {
  matAltRoute,
  matBadge,
  matBalance,
  matBusinessOutline,
  matCalendarMonthOutline,
  matCameraAlt,
  matChat,
  matChatBubbleOutline,
  matCheckBox,
  matDesignServicesRound,
  matDiamond,
  matEco,
  matEmojiEvents,
  matEvent,
  matEventAvailable,
  matFitnessCenter,
  matFlag,
  matFunctions,
  matGridViewRound,
  matHandshake,
  matHeadsetOutline,
  matHome,
  matHowToReg,
  matHub,
  matInfo,
  matInputOutline,
  matLightbulb,
  matListAlt,
  matLocalBar,
  matMenuBook,
  matNewspaper,
  matNewspaperOutline,
  matPeopleAlt,
  matPersonRemove,
  matPets,
  matPlace,
  matPublic,
  matRestaurant,
  matSpeed,
  matSportsScore,
  matStar,
  matSupport,
  matTextSnippet,
  matVideoLibraryOutline,
  matWebStoriesOutline,
  matWorkspacePremium,
};
